export default "__VITE_ASSET__BJEp5I_7__"